import script from "./procureOutWarehouse.vue?vue&type=script&setup=true&lang=js"
export * from "./procureOutWarehouse.vue?vue&type=script&setup=true&lang=js"

import "./procureOutWarehouse.vue?vue&type=style&index=0&id=36a1095b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36a1095b"]])

export default __exports__